// Shared instructor constants. Extracted from InstructorPage.jsx during the
// iter-35 split so every sub-component uses the same list without circular
// imports.
export const DEPTHS = [
  { id: "quick", label: "Quick — 8 Qs" },
  { id: "standard", label: "Standard — 25 Qs" },
  { id: "deep", label: "Deep — 50 Qs" },
  { id: "certification", label: "Certification — 100 Qs" },
];
